exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custom-control-label[data-v-77d55e78] {\n    font-weight: 500;\n}\n.custom-switch .custom-control-label[data-v-77d55e78]::before {\n    border-radius: 0.5rem;\n}\n.custom-switch .custom-control-label[data-v-77d55e78]::after {\n    border-radius: 50%;\n}\n", ""]);

// exports
